var GlobalVarsServiceModule = /** @class */ (function () {
    function GlobalVarsServiceModule() {
    }
    return GlobalVarsServiceModule;
}());
export { GlobalVarsServiceModule };
